/**
 * Список голосований — ТОЧНАЯ КОПИЯ legacy htdocs/core/templates/main_votes.tpl
 * (ветка `isset($data.votelist)`, т.е. votes() при id < 1).
 *
 * Разметка 1:1: table.table.table-hover, колонки Тема / Статус / Период проведения /
 * Приняли участие, статусы теми же цветами (#ca0000, green, #caca00).
 *
 * В список попадают только онлайн-голосования (legacy: SELECT * FROM votes_list WHERE is_online)
 * — это поле `online` ответа GET /api/votes. Счётчик «X из Y» — `counters`,
 * отметка «Проголосовал» — `answered`.
 *
 * Ссылка: legacy /votes?id={id} → в React-роутере /votes/{id} (App.tsx: votes/:id).
 */

import { Link } from 'react-router-dom'

import type { Vote } from '@/api/types'
import { formatDate } from '@/lib/format'
import { useApi } from '@/lib/useApi'

/** GET /api/votes (Handlers\User\Votes::list). */
interface VotesData {
  votes: Vote[]
  online: Vote[]
  counters: Record<number, string>
  answered: Record<number, boolean>
}

/** legacy сравнивает строки: $vote.date_end < date('Y-m-d'). */
function today(): string {
  const now = new Date()
  const pad = (n: number): string => (n < 10 ? '0' + String(n) : String(n))
  return `${String(now.getFullYear())}-${pad(now.getMonth() + 1)}-${pad(now.getDate())}`
}

export function VotesPage() {
  const { data } = useApi<VotesData>('/api/votes')

  // до загрузки $data.votelist в legacy не задан — не рендерится ни один из блоков
  if (data === null) return <div />

  const votelist = data.online
  const now = today()

  return (
    <div>
      {votelist.length < 1 && (
        <div style={{ fontSize: '20px', paddingTop: '20px', textAlign: 'center' }}>
          Активных голосований нет
        </div>
      )}

      {votelist.length >= 1 && (
        <div className="row" style={{ paddingTop: '20px' }}>
          <div className="col-sm-12">
            <table className="table table-hover">
              <thead>
                <tr>
                  <th>Тема</th>
                  <th>Статус</th>
                  <th>Период проведения</th>
                  <th>Приняли участие</th>
                </tr>
              </thead>
              <tbody>
                {votelist.map((vote) => (
                  <tr key={vote.id}>
                    <td>
                      <div>
                        <Link to={`/votes/${vote.id}`} style={{ paddingRight: '20px' }}>
                          {vote.name}
                        </Link>
                      </div>{' '}
                    </td>
                    <td>
                      {vote.date_end < now && <div style={{ color: '#ca0000' }}>Завершено</div>}
                      {vote.date_end > now &&
                        (data.answered[vote.id] === true ? (
                          <div style={{ color: 'green' }}>Проголосовал</div>
                        ) : (
                          <div style={{ color: '#caca00' }}>Открыто для голосования</div>
                        ))}
                    </td>
                    <td>
                      с {formatDate(vote.date_start)} по {formatDate(vote.date_end)}
                    </td>
                    <td>{data.counters[vote.id]}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  )
}
